import JWT from '@api/jwt'

// Token Search. This sets token. Invalidate token by changing tokenVersion:

const DAY = 24 * 60 * 60 * 1000
const YEAR = 365 * DAY
const tokenVersion = 'v2'

const userToken = ({ _id, contact: { email }}, long, outdated) => {
    const validityTime = (outdated ? 0 : (long ? YEAR : DAY))
    return JWT.encode({ _id, email, tokenVersion }, validityTime)
}

export { tokenVersion }
export default userToken